import React, { useState, useContext, useEffect } from "react";
import { DashboardContext } from "../../../../context/DashboardContext";
import { GeneralContext } from "../../../../context/GeneralContext";
import {
  dataPointsUpdateWithOptions,
  revertDataPointsToOriginalUnits,
} from "./processingLogic";
import RawAndSolved from "./RawAndSolved";
import ProcessingOptions from "./ProcessingOptions";
import "./fileProcessing.scss";
import { deepCopy } from "../../Models/modelLogic";
import { revertToOriginalPoints, updateFileDataAfterOptionChange } from "../../../../utils/helpers";

function SingleFileReprocess(props) {
  const { file, handleDone, handleCancel, modalId } = props;
  const { filePresetsLoadingOptions, setfilePresetsLoadingOptions, defaultXAxisUnit } =
    useContext(DashboardContext);
  const { recordedErrorLog } = useContext(GeneralContext);
  const [processedContent, setProcessedContent] = useState("");
  const [originalPoints, setOriginalPoints] = useState(null);

  useEffect(() => {
    if (file) {
      const copyOfFile = deepCopy(file);

      const revertedDataPoints = revertToOriginalPoints(
        copyOfFile.dataPoints,
        copyOfFile.options
      );

      const revertedToOrgUnits = revertDataPointsToOriginalUnits(
        revertedDataPoints,
        copyOfFile.xUnit
      );

      setOriginalPoints(revertedToOrgUnits);
      const dataPoints = dataPointsUpdateWithOptions(
        revertedToOrgUnits,
        file.options,
        recordedErrorLog
      );

      setProcessedContent(dataPoints || []);
    }
  }, [file]);

  const handleSave = (optionObject) => {
    try {
      const saveName = prompt("Name your option set:");
      if (saveName !== null) {
        const largestIdObj = filePresetsLoadingOptions.reduce((acc, curr) => {
          return acc.id > curr.id ? acc : curr;
        }, filePresetsLoadingOptions[0]);

        setfilePresetsLoadingOptions((old) => [
          ...old,
          {
            presetName: saveName,
            id: largestIdObj.id + 1,
            presetOptions: optionObject,
          },
        ]);
      }
    } catch (error) {
      recordedErrorLog("Save handler failure: ", error);
    }
  };



  const handleApply = (optionObject) => {
    try {
      const dataPoints = dataPointsUpdateWithOptions(
        originalPoints,
        optionObject,
        recordedErrorLog
      );

      if (dataPoints !== null) {
        const fileData = updateFileDataAfterOptionChange(deepCopy(file), dataPoints, optionObject, defaultXAxisUnit);
        handleDone(fileData);
      } else {
        setProcessedContent(dataPoints || []);
      }
    } catch (error) {
      recordedErrorLog("Apply handler has failed: ", error);
    }
  };

  const handleCheck = (optionObject) => {
    try {
      if (originalPoints && originalPoints.length > 0) {
        const dataPoints = dataPointsUpdateWithOptions(
          originalPoints,
          optionObject,
          recordedErrorLog
        );

        setProcessedContent(dataPoints || []);
      } else {
        setProcessedContent([]);
      }
    } catch (error) {
      recordedErrorLog("Check handler has failed: ", error);
    }
  };

  return (
    <div className="singleFileReprocess">
      <RawAndSolved
        rawFileContent={originalPoints !== null ? originalPoints : ""}
        processedContent={processedContent}
        options={file?.options || {}}
        single
        modalId={modalId}
      />
      <div className="divider" />
      <ProcessingOptions
        save={handleSave}
        apply={handleApply}
        check={handleCheck}
        modalId={modalId}
        cancel={handleCancel}
        single
        processedContent={processedContent}
        initialOptions={file?.options}
      />
    </div>
  );
}

export default SingleFileReprocess;
